import ReactDOM, { Root } from 'react-dom/client';
import { Component, ReactNode } from 'react';
import CommonPopup from '../../components/CommonPopup';
import PopupMessage from '../../components/PopupMessage';
import Alert from '../../components/Alert';

interface MountRoot {
    container: HTMLElement;
    root: Root;
}

let mountRoot: MountRoot | null = null;
let hide: any = null;
let timer: any = null;

function clearTimer() {
    if (timer) {
        clearTimeout(timer);
        timer = null;
    }
}

interface CommonMessageProps {
    duration?: number;
    comp: (active: boolean) => ReactNode;
}

interface CommonMessageState {
    active: boolean;
}

class CommonMessage extends Component<CommonMessageProps, CommonMessageState> {
    constructor(props: CommonMessageProps) {
        super(props);
        this.state = {
            active: false
        };
        hide = () => {
            this.setState({
                active: false
            });
        };
    }
    componentDidMount() {
        clearTimer();
        timer = setTimeout(() => {
            this.setState({
                active: true
            });
            if (undefined === this.props.duration || null === this.props.duration || 0 < this.props.duration) {
                clearTimer();
                timer = setTimeout(close, 1000 * (this.props.duration || 3));
            }
        });
    }
    render(): ReactNode {
        return this.props.comp(this.state.active);
    }
}

function destroyPopupInst() {
    hide = null;
    if (mountRoot) {
        mountRoot.root.unmount();
        document.body.removeChild(mountRoot.container);
        mountRoot = null;
    }
    clearTimer();
}

function close() {
    clearTimer();
    timer = setTimeout(() => {
        if (hide) {
            hide();
            hide = null;
            clearTimer();
            timer = setTimeout(destroyPopupInst, 500);
        } else {
            destroyPopupInst();
        }
    }, 500);
}

function commonMessage(comp: (active: boolean) => ReactNode, duration?: number) {
    destroyPopupInst();
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = ReactDOM.createRoot(
        container as HTMLElement
    );
    mountRoot = {
        container: container,
        root: root
    };
    root.render(<CommonMessage comp={comp} duration={duration}></CommonMessage>);
}

export function success(msg: string, duration?: number) {
    commonMessage((active: boolean) => {
        return (
            <PopupMessage type="success" message={msg} active={active} />
        );
    }, duration);
}

export function warning(msg: string, duration?: number) {
    commonMessage((active: boolean) => {
        return (
            <PopupMessage type="warning" message={msg} active={active} />
        );
    }, duration);
}

export function error(msg: string, duration?: number) {
    commonMessage((active: boolean) => {
        return (
            <PopupMessage type="error" message={msg} active={active} />
        );
    }, duration);
}

export function popupMessage(children?: ReactNode, duration?: number) {
    commonMessage((active: boolean) => {
        return (
            <CommonPopup active={active}>
                {children}
            </CommonPopup>
        );
    }, duration);
}

function alert(content: string, title?: string) {
    (Alert as any).show(content, title || 'Notification', 'ok');
}

export default {
    popupMessage,
    success,
    warning,
    error,
    close,
    alert
};
